(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// ------------------------------------
//
// Theme
//
// ------------------------------------

(function ($) {

	if (typeof window.Theme == 'undefined') window.Theme = {};

	Theme = {

		settings: {},

		/*
		 * Theme init
		 */

		init: function () {


			// Share
			// this.share();

			// Header Carousel
			this.carouselHeader();

			// Social Feeds
			// this.social();

			// Cookie Policy
			this.cookiePolicy();

		},

		// ------------------------------------
		// Social
		// ------------------------------------

		social: function () {

			$('[data-social="instagram"]').socialFeed({});

		},

		// ------------------------------------
		// Share JS
		// ------------------------------------

		share: function () {

			// Setup

			$("a[data-share]").share({
				counts: false
			});

		},

		// Carousel Header
		carouselHeader: function () {

			// Simple Carousel
			if ($('.header-carousel').length <= 0) return;

			var active = 1;
			var $items = $('.header-carousel-image');

			setInterval(function () {

				$('.header-carousel-image').removeClass('active');
				$('.header-carousel-image').eq(active).addClass('active');
				active++;

				if (active >= $items.length) active = 0;

			}, 5000);

		},
		cookiePolicy: function () {

			// Guard
			if (Util.getCookie('cookie_policy_accepted')) return;

			// Display Banner
			$('.cookie-policy-banner').addClass('-active');

			// Add Clock
			$('.cookie-policy-banner .close').on('click', function (e) {
				e.preventDefault();
				$('.cookie-policy-banner').removeClass('-active');
				Util.setCookie('cookie_policy_accepted', true, 365);
			})

		}

	};

	module.exports = Theme;

})(jQuery);

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/modules/theme.js","/modules")